import { GetUserResponseBody, PixiesetAccountInfoStatus, UserSubscription } from "./dto/users"

export const activePolarrSubscription = (user?: GetUserResponseBody): UserSubscription | null => {
	return (
		user?.subscriptions?.filter((subscription) => subscription.status === "active")?.[0] ?? null
	)
}

export const hasUserActiveSubscription = (user?: GetUserResponseBody): boolean => {
	if (!user) {
		return false
	}

	return (
		activePolarrSubscription(user) !== null ||
		user.pixiesetSubscription?.accountInfoStatus === PixiesetAccountInfoStatus.Upgraded
	)
}

export const getGenAiCreditsTooltipKey = (user?: GetUserResponseBody): string => {
	return hasUserActiveSubscription(user)
		? "account.genAiSubscriberCreditsTooltip"
		: "account.genAiFreeUserCreditsTooltip"
}
